import {
    HANDWRITING_PROJECT_FONT_ALL_VALUES,
    HANDWRITING_PROJECT_FONTS,
    type HandwritingProjectFont,
    type HandwritingProjectPresetFont,
} from '~~/layers/base/constants/handwritingProjectFont'

/** Runtime guard: preset stem only (a loaded `.ttf` exists). */
export function isHandwritingProjectPresetFont(
    value: string
): value is HandwritingProjectPresetFont {
    return HANDWRITING_PROJECT_FONTS.some((f) => f.stem === value)
}

/**
 * Runtime guard for `handwriting_project.font` and form state: preset stems or
 * {@link HANDWRITING_PROJECT_FONT_CUSTOM}.
 */
export function isHandwritingProjectFont(value: string): value is HandwritingProjectFont {
    return (HANDWRITING_PROJECT_FONT_ALL_VALUES as readonly string[]).includes(value)
}
